export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const SET_ALERT = "SET_ALERT";
export const SET_ALERTS = "SET_ALERTS";
export const SET_LOADED = "SET_LOADED";
export const SET_LOADING = "SET_LOADING";
export const SET_PAGE_INFO = "SET_PAGE_INFO";

export const REM_ALERT = "REM_ALERT";
export const REM_ALERTS = "REM_ALERTS";

export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const PASSWORD_CHANGE = "PASSWORD_CHANGE";
export const PERMISSIONS_LOADED = "PERMISSIONS_LOADED";
export const API_CALL_FAILED = "API_CALL_FAILED";
export const RESET_FAILED = "RESET_FAILED";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const VERIFY_TOKEN_FAILED = "VERIFY_TOKEN_FAILED";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
